var lastanchoredHash = null;
var skip_listenScrollHashChange = false;
var scrollDetectFixedRowDelta_cache = null;

function scrollDetectFixedRowDelta()
{
	if(scrollDetectFixedRowDelta_cache===null)
	{
		var rows = $('.page_row');
		var delta = 0;
		for(let  i=0; i<rows.length; i++)
		{
			let row = rows.eq(i);
			if(row.css("position")=='fixed')
			{
				let _temp = 1*row.css('top').replace('px','')+row.height() - 5;
				if(_temp<200) // on ne prend pas en compte les éléments placé à plus de 200px du bord supérieur de la page
					delta = Math.max(_temp,delta);
			}
		}
		scrollDetectFixedRowDelta_cache = delta;
	}
	return scrollDetectFixedRowDelta_cache;
}

function scrollToElement(target)
{
	var W = $(window).width();
	if(W>1400)
		var extra_pad = $('body').data('scrollpad') || 0;
	else if(W>980)
		var extra_pad = $('body').data('scrollpadTablet') || 0;
	else
		var extra_pad = $('body').data('scrollpadMobile') || 0;

	var target = $(target);
	var target_offset = target.offset();
	if(target_offset)
	{
		var target_top = target_offset.top - 1*(target.css('marginTop').replace('px','')) - scrollDetectFixedRowDelta();
		//$('html,body').css({'scroll-behavior':'initial'});
		$('html,body').stop().animate({scrollTop:target_top - extra_pad}, 1000, 'swing',function(){
			//$('html,body').css({'scroll-behavior':'smooth'});
		});
	}
}
window.scrollToElement = scrollToElement;

// -------------------------
var lastanchoredHash = null;
function scrollToHashAnchor(url=null){
	var full_url = url || window.location.href;
	var parts = full_url.split("#");
	var trgt = parts[1];
	if(trgt !== undefined && trgt.length>0){
		//clearInterval(scrollToAnchorOnStartup_interval);
		trgt = trgt.split("!");
		if(trgt.length>1)
		{
			trgt = trgt[1].replace(/;.*/,'');
			if(lastanchoredHash !== trgt)
			{
				lastanchoredHash = trgt;
				scrollToElement("#"+trgt);
			}
		}
	}
}
function listenScrollHashChange()
{
	if(!skip_listenScrollHashChange)
		scrollToHashAnchor();
	skip_listenScrollHashChange = false;
}

function scrollDownOnClick(){
	$(document).on('click','a[data-scrolldown="true"],span[data-scrolldown="true"]',function(event){
		//clearInterval(scrollToAnchorOnStartup_interval);
		event.stopPropagation();
		event.preventDefault();
		var current = $(this).parents('.page_row').eq(0);
		var found = false;
		$('.page_row:visible').each(function(){
			if($(this).is(current))
			{
				found=true;
			}
			else if(found)
			{
				scrollToElement($(this));
				found=false;
			}
		})
	});
}

var scrollToAnchorOnStartup_interval = null;
$(document).ready(function(){
	$('html,body').scrollTop(0);
	scrollToAnchorOnStartup_interval = setTimeout(scrollToHashAnchor, 500);
	scrollDownOnClick();

	window.addEventListener("hashchange", listenScrollHashChange, false);

	var CURRENT_PAGE = $('link[rel="canonical"]').eq(0).attr('href');

	$('a[href*="#!"]').not('[onclick]').each(function(){
		$(this).on('click',function(e){
			var url = $(this).attr('href').split('#')[0];
			if(url=='' || url==CURRENT_PAGE)
			{
				skip_listenScrollHashChange = true;
				//e.preventDefault();
				lastanchoredHash = null;
				scrollToHashAnchor($(this).attr('href'));
			}
		})
	})
});